import { FeaturePanel } from '@engine/features/feature_panel';
var container = '.allowed-domains-wrapper';
var Panel = new FeaturePanel(container, {
  errorMessageTemplate: function errorMessageTemplate(message, errors) {
    return message + '</br>' + errors[1];
  }
});

function getSelectedDomains() {
  return $(container + ' input')[0].selectize.getValue();
}

function listenForUpdates() {
  var $allowed_domains_selectize = $(container + ' input');

  if ($allowed_domains_selectize.length === 0) {
    return;
  }

  $allowed_domains_selectize[0].selectize.on('change', function () {
    Panel.update({
      allowed_domains: getSelectedDomains()
    });
  });
}

var WpfAllowedDomains = {
  listenForUpdates: listenForUpdates
};
export default WpfAllowedDomains;